<template>
  <div>
    <v-row class="rounded no-gutters back-filtro pa-1" justify="center" align="center">
      <v-col cols="12" class="ma-0 pa-0 d-flex align-center">
        <span class="subtitle-1 font-weight-bold" color="primary">{{title}}</span>
        <v-tooltip top>
          <template v-slot:activator="{ on }">            
            <v-btn text icon color="primary" class="ml-auto" x-small @click="remove" v-on="on">
              <v-icon dark small>fa-trash-alt</v-icon>
            </v-btn>
          </template>
          <span>{{ $store.state.jsIdioma.oEquivalencias.btnEliminarFiltro }}</span>
        </v-tooltip>
      </v-col>
      <v-col cols="12">
        <span class="text-primary">{{ $store.state.jsIdioma.oEquivalencias.lblSeleccioneOpcion }}</span>
        <v-select
          :items="itemsSelect"
          item-text="titulo"
          item-value="valor"
          v-model="selectOpcion"
          hide-details
          outlined
          dense>
        </v-select>
      </v-col>
      <v-col v-if="selectOpcion!='between'" cols="12" class="py-0 ma-0 ColumnaResumida">
        <span class="text-primary">{{ $store.state.jsIdioma.oEquivalencias.lblValoraFiltrar }}</span>
        <v-radio-group
          v-model="valorConsulta"
          row>
          <v-radio
            :label="$store.state.jsIdioma.oEquivalencias.lblAct"
            value="1"
          ></v-radio>
          <v-radio
            :label="$store.state.jsIdioma.oEquivalencias.lblDesAct"
            value="0"
          ></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import mixinGridComponenteFiltros from "@/mixins/GridComponenteFiltros.js"
  
  export default {
    name:"CampoSiNo",
    mixins: [mixinGridComponenteFiltros],
    data() {
      return {
        itemsSelect: [
          // {titulo:'Contiene',valor: 'LIKE'},
          {titulo:'Igual',valor: '='},

        ],
        selectOpcion  : '=',
        valorConsulta : this.value,
      }
    },
    methods: {
      stringConsulta (){
        let sConsulta = ''
        switch (this.selectOpcion) {
          case '': {
            sConsulta = ''
            break
          }
          case 'LIKE': {
            sConsulta = `LIKE '^${this.valorConsulta}^'`
            break
          }            
          case '=': {
            sConsulta = `= '${this.valorConsulta}'`
            break
          }
        }
        this.$emit("input",sConsulta)
      }
    },
    watch: {
      valorConsulta() {
        this.stringConsulta();
      },
      selectOpcion() {
        this.stringConsulta();
      },

    },
  }
</script>

<style scoped>
</style>